//* Style
import ButtonLoadingStyle from './style';

const ButtonLoading = ({ className }) => {
	return <ButtonLoadingStyle className={`loader ${className || ''}`} />;
};

export default ButtonLoading;
